<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 搜索区域 -->
            <!-- 搜索和添加区域 -->
      <el-row :gutter="20">
        <el-col :span="9">
          <el-input placeholder="请输入搜索内容" v-model="queryInfo.query" class="input-with-select" clearable >
            <el-button slot="append" icon="el-icon-search" @click="getList(true)"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="adduser()">添加</el-button>
                 
        </el-col>
        <el-col :span="4">
         
          <el-button type="info" @click="upexcel()">上传EXCEL</el-button>          
        </el-col>        
      </el-row>

      <!-- 列表区域 -->
      <el-table :data="list" border  style="width: 100%"  >       
        <el-table-column prop="id" label="id" width="100px"></el-table-column>
        <el-table-column prop="model" label="型号"> </el-table-column>        
        <el-table-column prop="skincode" label="编号"></el-table-column>      
        <el-table-column prop="mainmodel" label="主编号"></el-table-column>            
        <el-table-column prop="types" label="产品类别"></el-table-column>
        <el-table-column prop="memo" label="说明"></el-table-column> 
        <el-table-column prop="type" label="类型全称"></el-table-column>  
        <el-table-column prop="price" label="价格"></el-table-column>                 
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="edituser(scope.row,scope.$index)">编辑</el-button>
            <!-- 删除按钮 -->
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deluser(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="center"
      >
      </el-pagination>
    </el-card>
     <!-- 添加联系人对话框 -->
    <el-dialog title="上传" :visible.sync="addexcelVisible" width="50%" @close="upDialogClosed">
      <!-- 内容主体区域 -->

         <el-upload         
         :on-success="handle_success"
          class="upload-demo"
          :action="upurl"            
          multiple
          :file-list="fileList"
          :limit="1"
          :on-exceed="handleExceed"
          :before-upload="beforeupload"
          >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
</el-upload>
         
          <el-table  v-loading="loading" :data="uplist" border  style="width: 100%"    height="250" >       
             <el-table-column prop="id" label="id" width="100px"></el-table-column>
            <el-table-column prop="model" label="型号"> </el-table-column>        
            <el-table-column prop="skincode" label="编号"></el-table-column>      
            <el-table-column prop="mainmodel" label="主编号"></el-table-column>      
            <el-table-column prop="types" label="产品类别"></el-table-column>     
            <el-table-column prop="type" label="类别全称"></el-table-column>      
            <el-table-column prop="memo" label="说明"></el-table-column>     
          </el-table>  
 




   </el-dialog>

    <!-- 添加联系人对话框 -->
    <el-dialog title="编辑" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" ref="addFormRef" label-width="80px">
        <el-form-item label="型号" prop="model">
          <el-input v-model="addForm.model"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="skincode">
          <el-input v-model="addForm.skincode" ></el-input>
        </el-form-item>

        <el-form-item label="主编码" prop="mainmodel"> 
              <el-radio v-model="addForm.mainmodel" label="是">是</el-radio>
              <el-radio v-model="addForm.mainmodel" label="">否</el-radio>   
            
        </el-form-item>

        <el-form-item label="产品类别" prop="types">
          <el-input v-model="addForm.types" ></el-input>
        </el-form-item>

        <el-form-item label="类别全称" prop="type">
          <el-input v-model="addForm.type" ></el-input>
        </el-form-item>

        <el-form-item label="价格" prop="price">
          <el-input v-model="addForm.price" ></el-input>
        </el-form-item>


        <el-form-item label="说明" prop="memo">
          <el-input v-model="addForm.memo" ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button @click="saveuser()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mqtt from 'mqtt'
import glob_Data from '@/public/global_data.js' //导入全局变量	
import {formatDate} from "@/common/tool.js"

export default {
  components: {},
  data() {
    return {    
     
      // 获取列表参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 5,
      },
      list: [
        
      ],
      uplist:[],
      fileList:[],
      value: true,
      total: 0, 
      loading: false, 
      // 控制添加用户对话框的显示或隐藏
     addDialogVisible: false,
     addexcelVisible:false,
      // 添加用户
      addForm: {
        index:-1,
        id:0,        
        title: '',
        imgsrc: '',
 
      },

      // 控制修改用户对话框的显示或隐藏
      editDialogVisible: false,

      // 查询到的用户
      editForm: {},
      upurl: glob_Data.globaldata.serverurl+"ctl_skin_ht.fsp?proc=upfile"
    }
  },
  async created() {        
      this.getList();
      this.upurl+="&token="+ localStorage.getItem("token");  
  },
  methods: {
    handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
      beforeupload(){
        this.loading=true;
      },
     handle_success(res){
       console.log(res);
       if(res.errno!=0){
         this.$message.warning(res.errmsg);
         this.fileList=[];
         return; 
       }
       this.uplist=res.rows;       
       console.log(this.uplist);
       this.loading=false;
       
       //this.addForm.imgsrc=res.filename
      },
      upexcel(){
        this.uplist=[];
        this.fileList=[];
        this.addexcelVisible=true;        
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
    saveuser(){
         let _this = this
         if (!this.addForm.model){
          _this.$alert("型号不能为空", '系统提示');          
           return;
         }

         if (!this.addForm.skincode){
            _this.$alert("编码不能为空", '系统提示');          
           return;
         }

         var serverurl = glob_Data.globaldata.serverurl;
         let url = serverurl+"ctl_skin_ht.fsp?proc=save";                
         url+="&token="+ localStorage.getItem("token");        
         console.log(url) ;

        var sendata=this.addForm;
        this.$http({
          method: "post",//指定请求方式
          url: url,
          data:sendata          
        })
        .then(function(res){
          //接口成功返回结果执行
          if (res.data.errno!=0){
           _this.$alert(res.data.errmsg, '系统提示');          
           return;
          }          
          _this.fileList=[];
          if (_this.addForm.index!=-1){
             //_this.list[_this.addForm.index]=res.data.rows[0];
             _this.list.splice(_this.addForm.index,1,res.data.rows[0])
          }else{
            _this.list.push(res.data.rows[0])
          }
            _this.addDialogVisible = false
        })
        .catch(function(err){
            //请求失败或者接口返回失败或者.then()中的代码发生错误时执行
             _this.$alert(err, '系统错误');     
        })   
    },  
    deluser(item,index){
         let _this = this;
        this.$confirm('是否确认删除当前行？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确认',
          cancelButtonText: '放弃'
        })
          .then(() => {
                console.log("fff");
                var serverurl = glob_Data.globaldata.serverurl;
                let url = serverurl+"ctl_skin_ht.fsp?proc=save";  
                url+="&token="+ localStorage.getItem("token");                        
                var senddata=item;
                senddata.qystatus="del"
                this.$http({
                  method: "post",//指定请求方式
                  url: url,
                  data:senddata          
                })
                .then(function(res){
                  //接口成功返回结果执行
                  if (res.data.errno!=0){
                  _this.$alert(res.data.errmsg, '系统提示');          
                  return;
                  }
                  _this.list.splice(index,1);
                  _this.$message({
                    type: 'info',
                    message: '删除成功'
                  });
                })
                .catch(function(err){
                    //请求失败或者接口返回失败或者.then()中的代码发生错误时执行
                    _this.$alert(err, '系统错误');     
                })   

          })
          .catch(action => {  
          });     
     
    },
    adduser(){
       this.addForm={
         index:-1,
         model:"",
         skincode:"",
         mainmodel:"",
         type:"",
         types:"",
         memo:""        
       }     
       this.addDialogVisible=true;
    },
    edituser(item,index){
       console.log(index);
       this.addForm=item;
       this.addForm.index=index;      
            
       this.addDialogVisible=true;
       console.log(this.addForm);
    },
    // 获取列表数据
        getList(isnew) {
          if(isnew){
            this.queryInfo.pagenum=1
          }
            var serverurl = glob_Data.globaldata.serverurl;
            let url = serverurl+"ctl_skin_ht.fsp?proc=getlist"
            url+="&token="+ localStorage.getItem("token");        
          // Vue.prototype.$http = axios;
            var senddata={
              pagenum:this.queryInfo.pagenum,
              pagesize:this.queryInfo.pagesize,
              query:this.queryInfo.query
            }
            let _this = this
            this.$http.get(url, {
            // emulateJSON:false,
              params:senddata
            }).then(function (res) {            
              if(res.data.errno!=0){
                  _this.$alert(res.data.errmsg,"系统提示");
                  return;
              }
                _this.list = res.data.rows;
                _this.total=res.data.total;
                var myrows=res.data.rows;              

            }).catch(function (error) {

            })
        },
        handleSizeChange(e) {
          console.log(e)
          this.queryInfo.pagesize=e;
          this.getList()
        },
        handleCurrentChange(e) {
          console.log(e)
          this.queryInfo.pagenum=e;
          this.getList()
        },
            //监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },  
    upDialogClosed(){
       if(this.uplist.length>0) {
         this.getList();
         this.uplist=[];
         this.fileList=[];
       } 
    }
      
    
  },
}
</script>
<style>

.table {
  width: 900px;
  height: 400px;
  margin: 100px auto;
}

/*更改表格颜色*/
.alert {
  background: #f9fd00 !important;
}
.zero {
  background: rgb(255, 255, 255) !important;
}
.notzero {
  background: rgb(128, 1, 1) !important;
}

</style>
